module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-tag-section"
  }, [_c('div', {
    staticClass: "custom-tag-section__container"
  }, [_c('div', {
    staticClass: "custom-tag-section__nav"
  }, _vm._l((_vm.props), function(item, i) {
    return _c('div', {
      staticClass: "custom-tag-section__button-box",
      on: {
        "click": function($event) {
          _vm.showTab(i)
        }
      }
    }, [_c('a', {
      staticClass: "custom-tag-section__button",
      class: {
        active: _vm.isTab === i
      }
    }, [_vm._v(_vm._s(item.button))])])
  })), _c('div', {
    staticClass: "divider"
  }), (this.isTab === 0) ? _c('div', {
    staticClass: "custom-tag-section__body"
  }, [_c('div', {
    staticClass: "custom-tag-section__left"
  }, [_c('div', {
    staticClass: "custom-tag-section__image",
    style: ({
      backgroundImage: 'url(' + _vm.props[0].image + ')'
    })
  })]), _c('div', {
    staticClass: "custom-tag-section__right",
    domProps: {
      "innerHTML": _vm._s(_vm.props[0].body)
    }
  }, [_vm._v(_vm._s(_vm.props[0].body))])]) : (this.isTab === 1) ? _c('div', {
    staticClass: "custom-tag-section__body"
  }, [_c('div', {
    staticClass: "custom-tag-section__left"
  }, [_c('div', {
    staticClass: "custom-tag-section__image",
    style: ({
      backgroundImage: 'url(' + _vm.props[1].image + ')'
    })
  })]), _c('div', {
    staticClass: "custom-tag-section__right",
    domProps: {
      "innerHTML": _vm._s(_vm.props[1].body)
    }
  }, [_vm._v(_vm._s(_vm.props[1].body))])]) : (this.isTab === 2) ? _c('div', {
    staticClass: "custom-tag-section__body"
  }, [_c('div', {
    staticClass: "custom-tag-section__left"
  }, [_c('div', {
    staticClass: "custom-tag-section__image",
    style: ({
      backgroundImage: 'url(' + _vm.props[2].image + ')'
    })
  })]), _c('div', {
    staticClass: "custom-tag-section__right",
    domProps: {
      "innerHTML": _vm._s(_vm.props[2].body)
    }
  }, [_vm._v(_vm._s(_vm.props[2].body))])]) : _c('div', {
    staticClass: "custom-tag-section__body"
  }, [_c('div', {
    staticClass: "custom-tag-section__left"
  }, [_c('div', {
    staticClass: "custom-tag-section__image",
    style: ({
      backgroundImage: 'url(' + _vm.props[3].image + ')'
    })
  })]), _c('div', {
    staticClass: "custom-tag-section__right",
    domProps: {
      "innerHTML": _vm._s(_vm.props[3].body)
    }
  }, [_vm._v(_vm._s(_vm.props[3].body))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc67ad3c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-tag-section/custom-tag-section.pug
// module id = 617
// module chunks = 1